import React, { lazy, Suspense } from 'react';
import AppRouter from './AppRouter';
import './scss/styles.scss';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { LicenseInfo } from '@mui/x-license';

import { UserContextProvider } from './UserContextProvider';
import ThemeProvider from './theme';
import { SettingsProvider } from './components/settings';
import ErrorBoundary from './ErrorBoundary';

const SettingsDrawer = lazy(() =>
  import('./components/settings').then(module => ({
    default: module.SettingsDrawer,
  }))
);

const ChatbotButton = lazy(() =>
  import('./components/Bot/ChatbotButton').then(module => ({
    default: module.default || module.ChatbotButton,
  }))
);

LicenseInfo.setLicenseKey(process.env.REACT_APP_MUI_LICENSE_KEY);

const toastConfig = {
  position: 'top-right',
  autoClose: 2000,
  newestOnTop: true,
};

export default function App() {
  return (
    <UserContextProvider>
      <ThemeProvider>
        <SettingsProvider
          defaultSettings={{
            themeLayout: 'horizontal', // 'vertical' | 'horizontal' | 'mini',
            bodhiPrimaryColor: '#3f51b5',
            bodhiSecondaryColor: '#e74c3c',
            bodhiPrimaryTextColor: '#ffffff',
            bodhiSecondaryTextColor: '#000000',
          }}
        >
          <ErrorBoundary>
            <Suspense fallback={null}>
              <SettingsDrawer />
            </Suspense>

            <AppRouter />
          </ErrorBoundary>

          <ToastContainer {...toastConfig} />

          <Suspense fallback={null}>
            <ChatbotButton />
          </Suspense>
        </SettingsProvider>
      </ThemeProvider>
    </UserContextProvider>
  );
}
